function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8748 0.969119C21.7966 0.969119 21.7185 1.00818 21.6404 1.04724L14.9998 3.46912L8.281 1.12537C8.00757 1.04724 7.73413 1.00818 7.46069 0.969119C7.22632 0.969119 6.95288 1.04724 6.67944 1.12537L0.781006 3.15662C0.312256 3.35193 -0.000244141 3.82068 -0.000244141 4.32849V17.8441C-0.000244141 18.2347 0.273193 18.4691 0.585693 18.4691C0.663818 18.4691 0.741943 18.4691 0.820068 18.4301L7.49975 15.9691L14.2185 18.3519C14.4529 18.4301 14.7263 18.4691 14.9998 18.4691C15.2732 18.4691 15.5076 18.4301 15.781 18.3519L21.6794 16.3207C22.1482 16.1254 22.4998 15.6566 22.4998 15.1488V1.63318C22.4998 1.24256 22.1873 0.969119 21.8748 0.969119ZM8.74975 3.27381L13.7498 5.03162V16.2035L8.74975 14.4457V3.27381ZM1.87476 16.0863V4.79724L6.87475 3.03943V14.2113H6.83569L1.87476 16.0863ZM20.6248 14.6801L15.6248 16.4379V5.26599L20.6248 3.39099V14.6801Z",
  fill: "white"
});

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.f59b4f05.svg";
export { ForwardRef as ReactComponent };